export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/Canada-c4a792645dbec6fb968c99ebfa298832.mp3";